module.exports = __webpack_public_path__ + "img/facilities-icon-2.2dcfc0cc.svg";